import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'
import { AlertTriangleFilled } from 'components/feather'

export const LinkContent = styled.span`
    display: inline-flex;
    align-items: center;
    column-gap: 8px;
`

export const Warning = styled(AlertTriangleFilled)`
    ${svgStroke()}

    color: var(--huma-color-foreground-warning);
`